import { css } from '@emotion/css'
import { fontFamily, fontSize, fontWeight, spacing, borderRadius, colors, shorthandHelper } from '@offerzen/pinata-shame'

import legacyColors from '../../lib/themes/colors'

export const headerHeight = 62

const styles = {
  container: css({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    height: headerHeight,
    background: legacyColors.darkEclipse,
    paddingLeft: spacing.large,
    paddingRight: spacing.large,
    position: 'relative',
    borderBottom: '1px solid rgba(41, 139, 242, 0.2)',
  }),

  inner: css({
    width: '1140px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: spacing.medium,
    paddingBottom: spacing.medium,
  }),

  logo: css({
    lineHeight: 0,
  }),

  logOutButton: css({
    marginLeft: 'auto',
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    border: `1px solid ${colors.geyser}`,
    backgroundColor: 'transparent',
    borderRadius: borderRadius.default,
    color: colors.white,
    padding: shorthandHelper([spacing.extraSmall, spacing.default]),
    transition: 'border-color .3s ease-out, background-color .3s ease-out',
    fontFamily: fontFamily.body,

    '&:hover': {
      cursor: 'pointer',
      borderColor: `${colors.cornflowerBlue} ${colors.mariner} ${colors.mariner} ${colors.cornflowerBlue}`,
      color: colors.white,
      backgroundColor: colors.cornflowerBlue,
    },
  }),
}

export default styles
